import { message, Modal } from 'antd';
import React, { useState } from 'react';
import ActionDropdown from './ActionDropdown';
import { handleBatchError } from '../../../../utils';
import { useBatchSetDataProductMutation } from '../../../../../../../graphql/dataProduct.generated';
import SetDataProductModal from '../../../../containers/profile/sidebar/DataProduct/SetDataProductModal';
import { useTranslation } from '../../../../../../../i18n/useTranslation';

type Props = {
    urns: Array<string>;
    disabled: boolean;
    refetch?: () => void;
    tooltip?: string;
};

// eslint-disable-next-line
export default function DataProductsDropdown({ urns, disabled = false, refetch, tooltip }: Props) {
    const { t } = useTranslation();
    const [isEditModalVisible, setIsEditModalVisible] = useState(false);
    const [batchSetDataProductMutation] = useBatchSetDataProductMutation();

    const batchUnsetDataProducts = () => {
        batchSetDataProductMutation({
            variables: {
                input: {
                    resourceUrns: urns,
                },
            },
        })
            .then(({ errors }) => {
                if (!errors) {
                    message.loading({ content: t('Loading...'), duration: 2 });
                    setTimeout(() => {
                        message.success({ content: t('Removed Data Product!'), duration: 2 });
                        refetch?.();
                    }, 2000);
                }
            })
            .catch((e) => {
                message.destroy();
                message.error(
                    handleBatchError(urns, e, {
                        content: t('Failed to remove assets from Data Product: \n {{message}}', {
                            message: e.message || '',
                        }),
                        duration: 3,
                    }),
                );
            });
    };

    return (
        <>
            <ActionDropdown
                name="Data Product"
                actions={[
                    {
                        title: t('Set Data Product'),
                        onClick: () => {
                            setIsEditModalVisible(true);
                        },
                    },
                    {
                        title: t('Unset Data Product'),
                        onClick: () => {
                            Modal.confirm({
                                title: t('If you continue, Data Product will be removed for the selected assets.'),
                                content: t('Are you sure you want to unset Data Product for these assets?'),
                                onOk() {
                                    batchUnsetDataProducts();
                                },
                                onCancel() {},
                                centered: true,
                                okText: t('Yes'),
                                cancelText: t('Cancel'),
                                maskClosable: true,
                                closable: true,
                            });
                        },
                    },
                ]}
                disabled={disabled}
                tooltip={tooltip}
            />
            {isEditModalVisible && (
                <SetDataProductModal
                    urns={urns}
                    currentDataProduct={null}
                    onModalClose={() => {
                        setIsEditModalVisible(false);
                    }}
                    refetch={refetch}
                />
            )}
        </>
    );
}
